// removed by extract-text-webpack-plugin
module.exports = {"container":"_23vzimDsw6rgQYHKc_vsQ6","market":"_1ovCKBHVD_L7HJA0fsvSqZ"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Markets/Desktop/styles.css
// module id = 1600
// module chunks = 85